import { render, staticRenderFns } from "./SimpleNewProcesso.vue?vue&type=template&id=08f4d9a6"
import script from "./SimpleNewProcesso.vue?vue&type=script&lang=js"
export * from "./SimpleNewProcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports